import { motion } from "framer-motion";
import { AUDIENCES } from "@/data/studio";
import { Section, SectionHeading } from "@/components/shared/Primitives";
import { revealStaggered, VIEW_NEAR } from "@/components/shared/motion";

export default function WhoWeWorkWith() {
  return (
    <Section id="audiences" testId="audiences-section">
      <SectionHeading
        overline="Who We Work With"
        title="Built for the people building something unusual."
      />
      <div className="mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {AUDIENCES.map((a, i) => (
          <motion.article
            key={a.id}
            data-testid={`audience-${a.id}`}
            variants={revealStaggered}
            initial="hidden"
            whileInView="show"
            viewport={VIEW_NEAR}
            custom={i * 0.08}
            className="rounded-2xl border border-white/10 bg-[#12141C]/45 p-8 backdrop-blur-xl transition-colors duration-500 hover:border-[#D4AF37]/40 md:p-10"
          >
            <span className="font-mono text-xs tracking-[0.3em] text-[#D4AF37]">{a.id}</span>
            <h3 className="font-display mt-5 text-lg font-semibold uppercase tracking-[0.12em] text-[#F4F6FB] md:text-xl">
              {a.title}
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-[#F4F6FB]/55">{a.content}</p>
          </motion.article>
        ))}
      </div>
    </Section>
  );
}
